import Box from '@mui/material/Box';
import CircularProgress, {
  CircularProgressProps,
} from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

const CircularProgressWithLabel = (
  props: CircularProgressProps & { value: number, noText?: boolean },
) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress size={55} thickness={5} variant="determinate"
        sx={{
          // width: "3.5rem",
          // height: "3.5rem",
          borderRadius: "100%",
          boxShadow: "inset 0 0 0px 4px gray",
          backgroundColor: "transparent",
          maxWidth: { xs: '3rem', sm: '100%' },
          maxHeight: { xs: '3rem', sm: '100%' },
          verticalAlign: { xs: 'text-top', sm: 'unset' }
        }}
        {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {
          props.noText ? null :
            <Typography
              variant="body6"
              component="div"
              color="text.primary"
            >{`${Math.round(props.value)}%`}</Typography>
        }
      </Box>
    </Box>
  );
}

export default CircularProgressWithLabel